export default "__VITE_ASSET__DMJ6FxXp__"